export function toHex(value: number, len: number): string {
  return pad(value.toString(16), len);
}

export function pad(s: string | number, len: number): string {
  let r = s.toString();
  while (r.length < len) {
    r = "0" + r;
  }
  return r;
}

export function generateId(type: string, data?: string) {
  let res = type;
  const end = data || "";
  while (res.length + end.length < 24) {
    res += "0";
  }
  return res + end;
}

export function hash(s: string) {
  let h = 3496329;
  for (let i = 0; i < s.length; i++) {
    // eslint-disable-next-line no-bitwise
    h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  }
  return h;
}

/**
 * Removes the non-printing character from a string
 * https://en.wikipedia.org/wiki/Control_character#In_Unicode
 */
export function removeNonPrintable(value: string) {
  // eslint-disable-next-line no-control-regex
  return value.replace(/[\u0000-\u001F\u007F-\u009F]/g, " ");
}

export function truncateString(str: string, maxLength: number) {
  if (str.length <= maxLength) {
    return str;
  }
  return str.substring(0, maxLength - 3) + "...";
}

export const toElipsis = (value: string) => (value.length > 2 ? "..." : value);
